document.getElementById('favolit-go-button').addEventListener('click', function() {
    var body = document.body;  
    body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');

    const element = document.querySelector('#fuji3-wishlist-side-container');
    const overlay2 = document.getElementById('overlay2');

    console.log(element);

    if (element) {
        element.classList.add('fav-slide-in');
        
        overlay2.style.display = 'block'; 
        overlay2.addEventListener('click', function() {
            element.classList.remove('fav-slide-in');
            overlay2.style.display = 'none';
        });
    } else {
        console.log('ウィッシュリストの要素が見つかりませんでした');
    }
});